<mat-form-field
  class="munily-text-field"
  [appearance]="materialAppearance"
  [floatLabel]="floatLabel"
  [class.munily-text-field--size-default]="size === 'default'"
  [class.munily-text-field--size-small]="size === 'small'"
  [class.munily-text-field--success]="showSuccessOutline()"
  [class.mat-form-field-invalid]="showError()"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <span matPrefix *ngIf="prefixText" class="munily-prefix-text">{{ prefixText }}</span>

  <mat-icon
    *ngIf="iconLeading"
    matPrefix
    class="munily-tf-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconLeading }}
  </mat-icon>

  <input
    matInput
    [type]="type"
    [placeholder]="placeholder"
    [formControl]="resolvedControl"
    [attr.maxlength]="maxLength != null ? maxLength : null"
    [attr.autocomplete]="autocomplete"
    (input)="onInput()"
    (blur)="onBlur()"
  />

  <mat-icon
    *ngIf="iconTrailing"
    matSuffix
    class="munily-tf-icon material-symbols-rounded"
    aria-hidden="true"
  >
    {{ iconTrailing }}
  </mat-icon>

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
  <mat-hint align="end" *ngIf="hasCharacterCounter && maxLength != null">
    {{ currentLength }}/{{ maxLength }}
  </mat-hint>

  <mat-error *ngIf="showError()">{{ resolvedErrorMessage }}</mat-error>
</mat-form-field>
